module.exports = __webpack_public_path__ + "static/img/Afjn.debe5fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Afjn.jpg
// module id = MkGQ
// module chunks = 1